exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".swiper-pagination[data-v-9bdee9f8] {\n  position: relative;\n}\n.swiper-container[data-v-9bdee9f8] {\n  padding: 20px 50px;\n}\n.dark-button[data-v-9bdee9f8] {\n  background: #000;\n  color: #fff;\n  height: 40px !important;\n  padding-top: 8px;\n}", ""]);

// exports
